/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

import * as Sentry from '@sentry/browser'

/**
 * Initialise Sentry from DI-container values. No-op when no DSN is configured
 * (e.g. dev environment).
 *
 * @type {Module}
 */
export default function init({ app }) {
    /** @type {string | undefined} */
    const dsn = app.get('dsn')
    if (!dsn) return

    Sentry.init({
        dsn,
        release: app.get('release'),
        environment: app.get('environment'),
        sendDefaultPii: true,
        ignoreErrors: [
            // Turbo view transitions the browser aborts or skips (hidden tab, superseded visit): harmless
            /Transition was (aborted|skipped)/,
            /View transition was skipped/,
        ],
    })

    Sentry.getCurrentScope().setUser(app.get('user'))
}
